<input hidden="true" accept="image/png, image/jpeg" type="file" #fileImagesElement (change)="onLoaded($event)">

<mat-card class="mat-elevation-z0">
    <mat-card-header>
        <mat-card-title>{{'test-model.title' | translate}}</mat-card-title>
        <mat-card-subtitle>{{'test-model.subtitle' | translate}}</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content style="text-align: center;">
        <app-ml-web-cam (onTakeSnapshot)="takeSnapshot($event)" [size]="50" [title]="'imagen de prueba'"
            [hidden]="!webcam.cameraOn" #webcam></app-ml-web-cam>


        <img *ngIf="testImageURL && !webcam.cameraOn" width="75px" id="imageTest" [src]="testImageURL">
        <p *ngIf="testImageURL">{{mostLikelyClass}}</p>

    </mat-card-content>

    <mat-card-actions class="action-centered">

        <button *ngIf="!webcam.cameraOn" mat-raised-button (click)="testImage()"
            matTooltip="{{ 'test-model.testImage.hint' | translate}}">
            <mat-icon>image</mat-icon>
        </button>
        <button *ngIf="!webcam.cameraOn" mat-raised-button (click)="testImageFromWebcam()"
            matTooltip="{{ 'test-model.testWebcam.hint' | translate}}">
            <mat-icon>photo_camera</mat-icon>
        </button>
        <button [disabled]="labeledDataManager.mlAlgorithm != 'neural-network'" matTooltip="{{ 'test-model.makeScratch.hint' | translate}}" (click)="loadScratch()"
            matTooltip="Hacer un programa en Scratch con este modelo" mat-raised-button>
            <img src="assets/images/scratch_icon.svg">
        </button>

        
    </mat-card-actions>

</mat-card>

<mat-card *ngIf="prediction" class="test-card">

    <mat-card-content>
        <p>{{confidenceText}}</p>
        <ul>
            <li *ngFor="let item of prediction">
                {{item[0] }} ({{item[1] * 100 | number:'1.2-2'}} %)
                <mat-progress-bar [value]="item[1] * 100">
                </mat-progress-bar>
            </li>
        </ul>

    </mat-card-content>
</mat-card>